// extracted by mini-css-extract-plugin
export default {"box":"model-row_box__Ig7GV"};